const configDetails = {
  // Audio Chunk Sending Control
  sendAudioChunk: process.env.REACT_APP_SEND_AUDIO_CHUNK,
  
  // Token Management Configuration
  tokenCheckIntervalMinutes: parseInt(process.env.REACT_APP_TOKEN_CHECK_INTERVAL_MINUTES) || 1,
  tokenRenewalThresholdMinutes: parseInt(process.env.REACT_APP_TOKEN_RENEWAL_THRESHOLD_MINUTES) || 3,
  
  // Audio S3 Recording Configuration
  chunkDurationMs: parseInt(process.env.REACT_APP_CHUNK_DURATION_MS) || 5000,
  urlRefillThreshold: parseInt(process.env.REACT_APP_URL_REFILL_THRESHOLD) || 3,
  urlBatchSize: parseInt(process.env.REACT_APP_URL_BATCH_SIZE) || 10,
  maxRetryCount: parseInt(process.env.REACT_APP_MAX_RETRY_COUNT) || 3,
  uploadRetryDelayMs: parseInt(process.env.REACT_APP_UPLOAD_RETRY_DELAY_MS) || 2000,
  
  // Transcription Model Names
  TRANSCRIPTION_MODEL_DEEPGRAM: 'deepgram',
  TRANSCRIPTION_MODEL_ASSEMBLYAI: 'assemblyai',
  
  //Metrics
  getUserMetrics: '/metrics/email',

  //Google Maps for address
  mapAPIKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,

  //Application Cognito User Auto Verification
  cognitoUserAutoVerification: process.env.REACT_APP_AUTO_USER_CONFIRMATION,

  // WebSocket URLs
  websocketBaseUrl: process.env.REACT_APP_WEBSOCKET_BASE_URL,
  assemblyWsBaseUrl: process.env.REACT_APP_ASSEMBLYAI_WS_BASE,
  deepgramWsBaseUrl: process.env.REACT_APP_DEEPGRAM_WS_BASE,
  baseUrl: process.env.REACT_APP_BASE_URL,
  trackingUrl: process.env.REACT_APP_TRACKING_API_URL,
  googleWebClientId: process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID,

  // Google config (consolidated from googleConfig.js)
  googleConfig: {
    clientId: process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID,
    scopes: ['https://www.googleapis.com/auth/calendar.readonly'],
  },

  googleLoginConfig: {
    onSuccess: () => {
      // Login success handled by caller
    },
    onError: () => {
      // Login error handled by caller
    },
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/calendar.readonly',
  },

  outlookClientId: process.env.REACT_APP_OUTLOOK_CLIENT_ID,

  // Outlook endpoints — frontend OAuth
  outlookAuthorizeEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',

  // Backend Outlook API (replaces direct Microsoft Graph calls) – moved to .env
  outlookBackendApiBaseUrl: process.env.REACT_APP_OUTLOOK_BACKEND_API_BASE_URL,
  outlookTokensEndpoint: '/tokens',
  outlookExchangeEndpoint: '/auth/outlook/exchange',
  outlookMeetingsEndpoint: '/meetings',

  // Google Calendar endpoint
  calendarApiUrl: 'https://www.googleapis.com/calendar/v3/calendars/primary/events',

  //Chatbot
  chatbotApiUrl: process.env.REACT_APP_CHATBOT_API_URL,

  PUBLIC_ACCESS: '/public_access',
  INSERT_MESSAGE: '/insert_message',
  GET_TOKEN: '/get_token',
  NOTIFY_MEETINGS: '/meetings',
  META_DATA: '/meta_data',
  SUMMARY_TEXT: '/summary_text',
  TRANSCRIPT: '/transcript',
  CONVERSATION_INITIATED: '/conversation_initiated',
  CONVERSATION_COMPLETED: '/conversation_completed',
  TRACKING_TIME:'/tracking_time',
  GET_TRACKING_TIME:'/get_tracking_time',
  UPLOAD_AUDIO:'/upload_audio',
  UPLOAD_STATUS: '/update_message',
  DELETE_NOTE: '/delete_note',
  GET_FILE_URLS:'/presigned_information',
  GET_S3_FILE_URL:'/get_presigned_url',
  AUDIO_PRESIGNED: '/audio_presigned',
  FEEDBACK: '/feedback',
  REPROCESS: '/reprocess',
  ANNOTATE: '/transcript/annotation',


  
  apiBaseUrlOrderservice: process.env.REACT_APP_ORDERSERVICE_BASE_URL,
  apiBaseUrlPaymentservice: process.env.REACT_APP_PAYMENTSERVICE_BASE_URL,
  // Order endpoints
  createOrder: '/orders/create',
  // Payment endpoints
  createStripePaymentEndpoint: '/payment/stripe/create-payment-intent',
  createPaypalPaymentEndpoint: '/payment/paypal/create-payment-intent',

  //Trial Activation
  activateTrialEndpoint: '/user/activate-trial',

  //Sales Service
  salesServiceBaseUrl: process.env.REACT_APP_NF_SALES_SERVICE_BASE_URL,
  contactSalesEndpoint: '/sales/contact',

  // Payment type options
  paymentTypes: {
    STRIPE: 'STRIPE',
    PAYPAL: 'PAYPAL'
  },

    // Control which payment types are available in the UI
    availablePaymentTypes: {
      STRIPE: process.env.REACT_APP_PAYMENT_STRIPE_ENABLED === 'true',
      PAYPAL: process.env.REACT_APP_PAYMENT_PAYPAL_ENABLED === 'true'
    },

  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    createStripePaymentEndpoint: '/payment/stripe/create-payment-intent',
  },

  paypal: {
    environment: process.env.REACT_APP_PAYPAL_ENVIRONMENT || 'sandbox', // 'sandbox' or 'production'
    currency: 'USD',
    sdkBaseUrl: 'https://www.paypal.com/sdk/js',
    createPaypalPaymentEndpoint: '/payment/paypal/create-payment-intent',
  },

  // WebSocket Reconnection Configuration
  MAX_RECONNECTION_ATTEMPTS: 5,
  RECONNECTION_DELAY_MS: 2000, // 2 seconds between attempts

  // Transcription Watchdog Configuration
  TRANSCRIPTION_WATCHDOG_INTERVAL_MS: parseInt(process.env.REACT_APP_TRANSCRIPTION_WATCHDOG_INTERVAL_MS) || 15000,
  TRANSCRIPTION_WATCHDOG_UNACKED_SPEECH_THRESHOLD_MS: parseInt(process.env.REACT_APP_TRANSCRIPTION_WATCHDOG_UNACKED_SPEECH_THRESHOLD_MS) || 30000,
  TRANSCRIPTION_WATCHDOG_MIC_ACTIVE_THRESHOLD_MS: parseInt(process.env.REACT_APP_TRANSCRIPTION_WATCHDOG_MIC_ACTIVE_THRESHOLD_MS) || 10000,

  // Audio queue limits (PCM buffers waiting to be sent to the transcription socket)
  AUDIO_QUEUE_MAX_BUFFERS: 100,
  AUDIO_QUEUE_KEEP_BUFFERS: 50,

  // Polling Configuration
  POLLING_INTERVAL: 3000, // 3 seconds for summary polling

  // PayPal Payment Status Polling Configuration
  paypalPolling: {
    interval: 2000, // 2 seconds between polling requests
    timeout: 300000, // 5 minutes (300 seconds) total polling timeout
    maxAttempts: 150, // Maximum polling attempts (300s / 2s = 150)
  },

  // Payment Status Endpoint (Order Service: /orders/payment/status/{paypalOrderId})
  getPaymentStatusEndpoint: '/orders/payment/status', // GET /orders/payment/status/{paypalOrderId}

};

export default configDetails;
